export enum ProducerType {
  UNKNOWN = 'UNKNOWN',
  Linqmatrix = 'Linqmatrix',
  Improvis = 'Improvis',
  Panosport = 'Panosport',
  Custom = 'Custom'
}
